import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

const VerificationName = 'Verification-Name' //技术信息添加页面所用请求的请求头

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getVerification() {
    return Cookies.get(VerificationName)
}

export function setVerification(verificationName) {
    return Cookies.set(VerificationName, verificationName)
}

export function removeVerification() {
    return Cookies.remove(VerificationName)
}
